import type { HealthStatus, ServiceDataResultOfAppModuleReport } from 'gql/graphql';
import type { BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';
import { formatDateToLocale } from 'utils';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

const statusMap: Record<HealthStatus, { label: string; status: BadgePropStatus }> = {
    HEALTHY: { label: 'Healthy', status: 'success' },
    DEGRADED: { label: 'Degraded', status: 'warning' },
    UNHEALTHY: { label: 'Unhealthy', status: 'error' },
};

export const useSystemInformationColumns = () => {
    const columns = useMemo<ColDef<any>[]>(
        () => [
            {
                headerName: 'Модуль',
                field: 'data.name',
                maxWidth: 264,
                minWidth: 264,
                colSpan: ({ data }) => (data?.data ? 1 : 7),
                cellRenderer: ({ data }: { data?: ServiceDataResultOfAppModuleReport }) => {
                    if (!data?.data && data?.message) {
                        return data.message;
                    }

                    return data?.data?.name || '';
                },
            },
            {
                headerName: 'Релиз',
                field: 'data.release',
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: 'Дата',
                field: 'data.buildDate',
                minWidth: 180,
                flex: 1,
                valueFormatter: ({ value }: { value: string }) => formatDateToLocale(value, true),
            },
            {
                headerName: 'Ветка',
                field: 'data.branch',
                minWidth: 160,
                flex: 1,
            },
            {
                headerName: 'Коммит',
                field: 'data.commit',
                minWidth: 160,
                flex: 1,
            },
            {
                headerName: 'Тэг',
                field: 'data.tag',
                minWidth: 160,
                flex: 1,
                cellRenderer: ({ data }: { data: ServiceDataResultOfAppModuleReport }) => {
                    const tag = data?.data?.tag;

                    if (!tag || tag === '-') {
                        return '—';
                    }

                    return tag;
                },
            },
            {
                headerName: 'Статус',
                field: 'data.healthCheckData.status',
                minWidth: 160,
                flex: 1,
                cellRenderer: ({ data }: { data: ServiceDataResultOfAppModuleReport }) => {
                    const status = data?.data?.healthCheckData?.status;

                    if (!status) {
                        return '—';
                    }

                    return <Badge {...statusMap[status]} />;
                },
            },
        ],
        [],
    );

    return { columns };
};
